import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSpinnerOverlayComponent } from 'src/app/components/mat-spinner-overlay/mat-spinner-overlay.component';
import { SnackBarService } from '../../services/snack-bar-service.service';
import { HabilitacaoSwapService } from '../services/habilitacao-swap.service';

@Component({
  selector: 'app-confirmar-submissao',
  templateUrl: './confirmar-submissao.component.html',
  styleUrls: ['./confirmar-submissao.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSpinnerOverlayComponent,
  ],
})
export class ConfirmarSubmissaoComponent {
  public loading = false;
  public dialogRef = inject(MatDialogRef<ConfirmarSubmissaoComponent>);
  private service = inject(HabilitacaoSwapService);
  private snack = inject(SnackBarService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: { totalSocios: number }) {}

  onCancelar(): void {
    this.dialogRef.close(false);
  }

  onConfirmar(): void {
    this.loading = true;
    this.service.submeterParaValidacao().subscribe({
      next: (response) => {
        this.loading = false;
        if (response?.sucesso) {
          this.dialogRef.close(response);
        }
      },
      error: () => {
        this.loading = false;
        this.snack.flashMessage(
          'Erro ao submeter para validação',
          ['snackbar-error'],
          'Fechar',
          3000
        );
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
